import { React, useEffect, useState } from 'react';
import { useParams, NavLink, Navigate } from 'react-router-dom';
import BackIco from "../../assets/images/homePage/back.png"

const iframeSources = {
    'beyondstay-checkout': 'https://preview-8148d024--stay-ease-checkout-flow.lovable.app/',
    'beyond-stay': 'https://preview--breezy-hotel-welcome.lovable.app/',
    'beyond-ease': 'https://preview--lead-genie-widget-ai.lovable.app/',
    'beyond-concierge': 'https://preview-32fec625--hotel-whisper-genie.lovable.app/',
    'beyond-calendar': 'https://preview-e7582351--bloom-booking-board.lovable.app/',
    'beyond-mail': 'https://preview-3a6ebfb7--hospitality-email-flow.lovable.app/templates'
};

const iframeMinHeights = {
    'beyondstay-checkout': '1100px',
    'beyond-stay': '900px',
    'beyond-ease': '1200px',
    'beyond-concierge': '1000px',
    'beyond-calendar': '1200px',
    'beyond-mail': '1250px'
};

const DotLoader = () => {
    return (
        <div style={styles1.loaderWrapper}>
            {[...Array(8)].map((_, i) => (
                <span
                    key={i}
                    style={{
                        ...styles1.dot,
                        transform: `rotate(${i * 45}deg) translate(40px)`,
                        animationDelay: `${i * 0.1}s`
                    }}
                />
            ))}
            <p style={styles1.text}>Loading brilliance...</p>
        </div>
    );
};

const styles1 = {
    loaderWrapper: {
        width: '50px',
        height: '50px',
        margin: '10px auto',
        position: 'relative',
    },
    dot: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '16px',
        height: '16px',
        margin: '-8px 0 0 -8px',
        borderRadius: '50%',
        background: 'linear-gradient(90deg, #5d44ff, #8673ff, #5d44ff)',
        animation: 'dotFade 1.2s infinite ease-in-out'
    },
    text: {
        marginTop: '30px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#5d44ff',
        fontWeight: '500'
    }
};

// Animation CSS
const styleSheet = `
@keyframes dotFade {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.7); }
}
`;

const GradientText = () => {    

    return (
        <div style={styles.wrapper}>

            <h1 style={styles.heading}>
                <DotLoader /> <style>{styleSheet}</style> <br />
                Preparing your personalized hospitality experience... <br />
                Unleashing brilliance — just a moment.</h1>

            <style>
                {`
          @keyframes slideGradient {
            0% { background-position: 0% 50%; }
            100% { background-position: 100% 50%; }
          }
        `}
            </style>
        </div>
    );
};

const styles = {

    wrapper: {
        textAlign: 'center',
        padding: '50px 20px',
        backgroundColor: '#f9fafc',
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    heading: {
        fontSize: '2.5rem',
        fontWeight: 700,
        fontFamily: 'sans-serif',
        background: 'linear-gradient(90deg, #5d44ff, #8673ff, #5d44ff)',
        backgroundSize: '200% auto',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: 'slideGradient 3s linear infinite',
        lineHeight: 1.2
    }
};

const BackButton = () => {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) return null;

    return (
        <NavLink
            to={"/what-we-offer"}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: '#fff',
                color: 'rgb(255, 255, 255)',
                border: 'none',
                padding: '8px 10px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 500,
                transition: 'background 0.3s'
            }}
            title='Back to Features'
        >
            <img
                src={BackIco}
                alt="Back"
                style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                }}
            />
        </NavLink>
    );
};



function DemoPages() {

    const [loading, setLoading] = useState(true);
    const { demoUrl } = useParams();
    const iframeSrc = iframeSources[demoUrl];
    const minHeight = iframeMinHeights[demoUrl] || '900px';


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 3000);

        return () => clearTimeout(timeout);
    }, []);

    if (loading) {
        return <GradientText />;
    }

    if (!iframeSrc) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <div style={{ position: 'relative', width: '100%' }}>
                <iframe
                    src={iframeSrc}
                    title={`${demoUrl}`}
                    height="100%"
                    width="100%"
                    style={{ border: 'none', minHeight }}
                />

                <div
                    style={{
                        position: 'absolute',
                        right: "10px",
                        bottom: "3px",
                        zIndex: 1,
                        height: '40px',
                        width: '160px',
                        borderRadius: "4px"
                    }}
                >

                    <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular" style={{ width: '170px' }}
                    >
                        Subscribe Now
                    </NavLink>
                </div>

                <div style={{ position: 'fixed', top: 20, left: 20, zIndex: '9991' }}>
                    <BackButton />
                </div>
            </div >
        </>

    );
}

export default DemoPages;
